import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import TableView from '../Common/TableView';

import { MessageDialogs, ModuleDialogs } from '../../constants/Dialogs';
import BulkEmailDialog from '../Message/BulkEmailDialog';
import ModuleEnrolmentTableRow, { ClassroomModuleEnrolmentTableRow } from './ModuleEnrolmentTableRow';
import ModuleEnrolmentDialog from './ModuleEnrolmentDialog';
import ModuleEventAssignmentDialog from './ModuleEventAssignmentDialog';
import ModuleEnrolmentByFilterDialog from './ModuleEnrolmentByFilterDialog';
import ModuleEnrolmentDeleteDialog from './ModuleEnrolmentDeleteDialog';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';

import AddEntityActionButton from '../Common/AddEntityActionButton';

import InfoIcon from 'material-ui/svg-icons/action/info';
import EmailIcon from 'material-ui/svg-icons/communication/email';
import EventIcon from 'material-ui/svg-icons/action/event';
import SignOutIcon from 'material-ui/svg-icons/navigation/cancel';
import FilterIcon from 'material-ui/svg-icons/content/filter-list';
import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import AppStore from '../../stores/AppStore';
import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import { sendBulkEmail } from '../../actions/MessageActionCreator';
import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleStore from '../../stores/ModuleStore';
import ModuleEventStore from '../../stores/ModuleEventStore';
import ModuleSubscriptionStore from '../../stores/ModuleSubscriptionStore';
import FilterActions from '../../actions/FilterActionCreator';
import FilterStore from '../../stores/FilterStore';
import SearchStore from '../../stores/SearchStore';

import Snackbar from 'material-ui/Snackbar';
import buildContextMenu from '../Common/BuildContextMenu';
import { withId } from '../Common/Decorators';

let defaultEnrolment = () => ({
    userId:         null,
    status:         'enrolled',
    assigned:       true,
    isMandatory:    false,

    statuses:       ModuleStore.getStatuses()
});

let defaultFilterEnrolment = () => ({
    filterId:       null,
    status:         'enrolled',
    assigned:       true,
    isMandatory:    false,

    filters:        FilterStore.getAll(),
    statuses:       ModuleStore.getStatuses()
});

const sortOptions = [
    { label: 'First Name',     value: 'firstName'     },
    { label: 'Last Name',      value: 'lastName'      },
    { label: 'Date Enrolled',  value: 'dateAdded'     },
    { label: 'Date Completed', value: 'dateCompleted' }
];

class ModuleEnrolments extends Component {

    componentDidMount() {
        this.moduleChange = this.moduleChange.bind(this);
        this.onSaveEnrolment = this.onSaveEnrolment.bind(this);
        this.onRowSelection = this.onRowSelection.bind(this);
        this.openEventAssignmentDialog = this.openEventAssignmentDialog.bind(this);
        this.onAssignUsers = this.onAssignUsers.bind(this);
        this.openMessageDialog = this.openMessageDialog.bind(this);
        this.onSaveEnrolmentByFilter = this.onSaveEnrolmentByFilter.bind(this);
        this.onDeleteEnrolment = this.onDeleteEnrolment.bind(this);
        this.onSuccessMessage = this.onSuccessMessage.bind(this);
        this.onCloseSnackbar = this.onCloseSnackbar.bind(this);
        this.filter = this.filter.bind(this);
        this.sort = this.sort.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.search = this.search.bind(this);
        this.toggleSearchMode = this.toggleSearchMode.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.listeners = [
            ModuleStore.addListener(this.moduleChange),
            AppStore.addSuccessListener(this.onSuccessMessage),
            SearchStore.addListener(this.onSearch)
        ];

        ModuleActions.getById(this.props.routeParams.id);
        ModuleActions.getSubscriptions(this.props.routeParams.id);
        FilterActions.getAll();

        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());

        window.removeEventListener('scroll', this.handleScroll);
    }

    getDialog() {
        switch (this.state.dialog) {
            case ModuleDialogs.ENROLMENT_ADD:
                return (
                    <ModuleEnrolmentDialog
                        onSave={this.onSaveEnrolment}
                        title="Add enrolment"
                        moduleId={this.props.id}
                        events={this.state.moduleEvents}
                    />
                );

            case ModuleDialogs.ENROLMENT_EDIT:
                return (
                    <ModuleEnrolmentDialog
                        onSave={this.onSaveEnrolment}
                        title="Edit enrolment"
                        moduleId={this.props.id}
                        events={this.state.moduleEvents}
                    />
                );

            case ModuleDialogs.ENROLMENT_BY_FILTER_ADD:
                return (
                    <ModuleEnrolmentByFilterDialog onSave={this.onSaveEnrolmentByFilter}/>
                );

            case ModuleDialogs.MODULE_EVENT_ASSIGN:
                return (
                    <ModuleEventAssignmentDialog
                        events={this.state.moduleEvents}
                        onSave={this.onAssignUsers}
                    />
                );

            case ModuleDialogs.ENROLMENT_DELETE:
                return (
                    <ModuleEnrolmentDeleteDialog
                        onSave={this.onDeleteEnrolment}
                    />
                );

            case MessageDialogs.BULK_EMAIL:
                return (
                    <BulkEmailDialog
                        onSave={({subject, message, users}) => sendBulkEmail(subject, message, users)}
                    />
                );

            default: break;
        }
    }

    render() {
        const isClassroom = !!this.state.module.type && this.state.module.type === 'classroom';
        const headers = [
            'Enrolled',
            'Name',
            'Completed',
            '',
            '',
            (isClassroom && 'Event'),
            ''
        ];

        const filterOptions = [
            {label: 'Show all', value: null},
            ...ModuleStore.getStatuses().map((s) => ({label: s.name, value: s.id}))
        ];
        
        return (
            <div ref="moduleEnrolments">
                <TableView
                    title={(<Link to={`/dashboard/module/${this.props.id}`}>{this.state.module.name}</Link>)}
                    subtitle='Module enrolments'
                    headers={headers}
                    rows={this.state.subscriptions}
                    decorator={isClassroom ? ClassroomModuleEnrolmentTableRow : ModuleEnrolmentTableRow}
                    backButton={true}
                    actions={buildContextMenu(this.getActions(), this.context.auth)}
                    multiSelectable={true}
                    enableSelectAll={true}
                    onRowSelection={this.onRowSelection}
                    filterOptions={filterOptions}
                    filterAction={this.filter}
                    sortOptions={sortOptions}
                    sortAction={this.sort}
                    searchAction={this.search}
                    toggleSearchMode={this.toggleSearchMode}
                >
                    {this.state.loading && (
                        <LinearProgress mode="indeterminate" />
                    )}
                    {this.state.showButton && (
                        <FlatButton
                            label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                            icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                            onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                            disabled={this.state.loading}
                            fullWidth
                        />
                    )}
                    {this.getDialog()}
                    <AddEntityActionButton onClick={() => DialogActions.open(ModuleDialogs.ENROLMENT_ADD, defaultEnrolment())} />
                    <Snackbar
                        open={this.state.showSuccessMessage}
                        action="OK"
                        message="Request successful. Users will shortly be assigned to this module."
                        onActionTouchTap={this.onCloseSnackbar}
                        onRequestClose={this.onCloseSnackbar}
                    />
                    <ErrorSnackbar/>
                </TableView>
            </div>
        );
    }

    getActions() {
        return [

            {
                link: `/dashboard/module/${this.props.id}`,
                icon: <InfoIcon />,
                label: 'Preview',
            },
            {
                action: () => DialogActions.open(ModuleDialogs.ENROLMENT_BY_FILTER_ADD, defaultFilterEnrolment()),
                icon: <FilterIcon />,
                label: 'Enrol by filter',
            },
            {
                type: 'divider'
            },
            {
                action: this.openMessageDialog,
                icon: <EmailIcon/>,
                label: 'Send message',
                condition: {
                    show: this.state.selected.length
                }
            },
            {
                action: this.openEventAssignmentDialog,
                icon: <EventIcon/>,
                label: 'Assign to event',
                condition: {
                    show: this.state.selected.length && this.state.module.type === 'classroom'
                }
            },
            {
                type: 'divider'
            },
            {
                link: '/logout',
                icon: <SignOutIcon />,
                label: 'Sign out',
            },
        ];
    }

    openEventAssignmentDialog() {
        if (this.state.selected.length === 0) { return; } // guard
        let users;
        
        if (this.state.selected === 'all') {
            users = this.state.subscriptions;
        } else {
            users = this.state.subscriptions.filter((user, i) => this.state.selected.includes(i));
        }
        users = users.map(({userId, title, firstName, lastName, eventId}) => ({id: userId, eventId, name: `${title || ""} ${firstName || ""} ${lastName || ""}`.trim()}));
        DialogActions.open(ModuleDialogs.MODULE_EVENT_ASSIGN, {users, eventId: null, moduleId: this.props.id });
    }

    openMessageDialog() {
        if (this.state.selected.length === 0) { return; } // guard
        let users;
        if (this.state.selected === 'all') {
            users = this.state.subscriptions;
        } else {
            users = this.state.subscriptions.filter((user, i) => this.state.selected.includes(i));
        }
        users = users.map(({userId, title, firstName, lastName}) => ({id: userId, name: `${title || ""} ${firstName || ""} ${lastName || ""}`.trim()}));

        DialogActions.open(MessageDialogs.BULK_EMAIL, {users, subject: '', message: ''});
    }
    
    // because the moduleStore is not new format yet
    moduleChange() {
        const module = ModuleStore.getById(this.props.id);
        if (module !== undefined) {
            this.setState({module});
            if (module.type === 'classroom') {
                ModuleActions.getEvents(this.props.id);
            }
        }
    }

    onSaveEnrolment(draft) {
        if (!draft.userId) { return false; } // userId is required
        const current = this.state.subscriptions.find((e) => (e !== undefined && e.moduleId === this.props.id && e.userId === draft.userId), this);
        const eventId = draft.eventId || (!!current && current.eventId) || null;
        if (draft.status === 'completed' && !!eventId) {
            const event = this.state.moduleEvents.find((e) => e !== undefined && e.id === eventId);
            if (event) {
                draft.success = 'passed';
                draft.location = event.venue;
                draft.notes = event.identificationNumber;
            }
        }
        ModuleActions.saveSubscription(this.props.id, draft.userId, draft, current);
    }

    onSaveEnrolmentByFilter(draft) {
        if (!draft.filterId) { return false; } // filterId is required
        ModuleActions.saveSubscriptionByFilter(this.props.id, draft.filterId, draft);
    }

    onDeleteEnrolment(draft) {
        if (!draft.userId) { return false; } // userId is required
        ModuleActions.deleteSubscription(this.props.id, draft.userId);
    }

    onAssignUsers({moduleId, eventId, users}) {
        if (!moduleId || !eventId || users.length === 0) { return false; } // guard
        const userList = users.map(user => user.id);
        ModuleActions.assignUsersToEvent(moduleId, eventId, userList);
    }

    onRowSelection(selected) {
        if (selected === this.state.selected) { return; } // guard
        if (selected === 'none') {
            if (this.state.selected.length === 0) { return; } // guard
            selected = [];
        }
        this.setState({selected});
    }

    onSuccessMessage() {
        this.setState({showSuccessMessage: true});
    }

    onCloseSnackbar() {
        this.setState({showSuccessMessage: false});
    }

    filter({filter}) {
        let subscriptions = ModuleSubscriptionStore.getModuleSubscriptions(this.props.id);
        if (!!filter) {
            subscriptions = subscriptions.filter((s) => s.status === filter);
        }
        this.setState({subscriptions});
    }

    sort({sort}) {
        if (sort === this.state.sort) { return; }

        let sortCriteria, sortMapCriteria;
        switch (sort) {
            case 'firstName':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.firstName});
                break;
            case 'lastName':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.lastName});
                break;
            case 'dateAdded':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({index: i, value: Date.parse(el.dateAdded) || 0});
                break;
            case 'dateCompleted':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({index: i, value: Date.parse(el.dateCompleted) || 0});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[sort]});
        }
        this.setState({sort, sortCriteria, sortMapCriteria, isLoading: true});
        ModuleActions.getSubscriptions(this.props.id, { sort }, true);
    }

    loadNextPage() {
        if (this.state.loading) { return; } //guard

        const page = !this.state.searchMode ? (this.state.page + 1) : (this.state.searchPage + 1);
        if (!this.state.searchMode) {
            ModuleActions.getSubscriptions(this.props.id, { page, sort: this.state.sort});
            this.setState({page});
        } else if (!!this.state.searchText) {
            ModuleActions.searchSubscriptions(this.props.id, this.state.searchText, {page});
            this.setState({searchPage: page});
        }
    }

    handleScroll() {
        if (!this.state.showButton && window.scrollY > 0) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) >= this.refs.moduleEnrolments.clientHeight) {
            this.loadNextPage();
        }
    }

    onSearch() {
        this.setState({
            fetchedAll: this.state.searchMode && SearchStore.fetchedAll(),
            loading: this.state.searchMode && SearchStore.isFetching()
        });
    }

    search(searchText) {
        this.timeout && clearTimeout(this.timeout);
        if (!!searchText && searchText.length > 2) {
            this.timeout = setTimeout(() => { ModuleActions.searchSubscriptions(this.props.id, searchText); }, 500);

            this.setState({
                searchText,
                searchPage: 0,
                showButton: false,
                fetchedAll: (searchText !== this.state.searchText ? false : this.state.fetchedAll)
            });
        }
    }

    toggleSearchMode(searchMode) {
        this.setState({
            searchMode,
            fetchedAll: false,
            showButton: false,
            searchText: (searchMode ? this.state.searchText : null),
        });
    }
}

ModuleEnrolments.getStores = () => ([ModuleSubscriptionStore, ModuleEventStore, DialogStore]);
ModuleEnrolments.calculateState = (prevState, {id}) => {
    const module = (!!prevState && prevState.module) || {};

    let subscriptions = ModuleSubscriptionStore.getModuleSubscriptions(id) || [];
    const sortCriteria = (!!prevState && prevState.sortCriteria) || null;
    const sortMapCriteria = (!!prevState && prevState.sortMapCriteria) || null;
    if (subscriptions.length > 0 && !!sortCriteria && !!sortMapCriteria) {
        const mapped = subscriptions.map(sortMapCriteria);
        mapped.sort(sortCriteria);
        subscriptions = mapped.map((el) => subscriptions[el.index]);
    }

    return ({
        module,
        moduleEvents: module.type === 'classroom' && ModuleEventStore.getByModule(id),
        selected: (!!prevState && prevState.selected) || [],
        subscriptions,
        dialog: DialogStore.getOpenDialog(),
        showSuccessMessage: false,
        page: (!!prevState && prevState.page) || 0,
        sort: (!!prevState && prevState.sort) || null,
        sortCriteria,
        sortMapCriteria,
        searchPage: (!!prevState && prevState.searchPage) || 0,
        searchMode: (!!prevState && prevState.searchMode) || false,
        searchText: (!!prevState && prevState.searchText) || null,
        loading: ModuleSubscriptionStore.isFetching(),
        fetchedAll: ModuleSubscriptionStore.fetchedAll(),
        showButton: !!prevState && prevState.showButton
    });
};

ModuleEnrolments.contextTypes = {
    auth:   PropTypes.object.isRequired
};

export default withId(Container.create(ModuleEnrolments, {withProps: true}));
